import { useSearchParams } from "react-router-dom";
import { useNetworkGraph } from "../../hooks/useNetworkGraph";
import { useNetworkScope } from "../../hooks/useNetworkScope";
import { MarketingNetworkGraph } from "./MarketingNetworkGraph";
import { hopsFrom } from "./networkGraph.model";

export type Props = {
  className?: string;
};

/**
 * Container for MarketingNetworkGraph.
 *
 * Asks the backend for the graph. Staff switch it on and off there, so the
 * answer may simply be that it is off, in which case, and if the request
 * fails, nothing is drawn.
 *
 * Which organizations it draws is the page's to say (`useNetworkScope`): every
 * approved one unless the address asks for a narrower set.
 *
 * The address can also say how far a chosen organization's neighbourhood
 * reaches, as `?hops=1` up to `?hops=6`, so the choices can be compared. It
 * is two unless told otherwise.
 */
export function MarketingNetworkGraphContainer({ className }: Props) {
  const scope = useNetworkScope();
  const [searchParams] = useSearchParams();
  const hops = hopsFrom(searchParams.get("hops"));
  const { data, isLoading } = useNetworkGraph(scope);
  const isMotionReduced =
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  return (
    <MarketingNetworkGraph
      data={data}
      isLoading={isLoading}
      isMotionReduced={isMotionReduced}
      hops={hops}
      className={className}
    />
  );
}

export default MarketingNetworkGraphContainer;
